export const MenuTab = {
  TICKET: 'TICKET',
  MARKET: 'MARKET',
};
